import { CrossIcon, TickCircleIcon } from 'evergreen-ui';
import { FunctionComponent } from 'react';

export type QuestionLabelProps = {
    label: string;
    markedResult?: boolean;
    description?: string;
    htmlFor?: string;
    props?: HTMLLabelElement;
};
export const QuestionLabel: FunctionComponent<QuestionLabelProps> = ({
    label,
    markedResult,
    description,
    htmlFor,
    ...props
}) => {
    return (
        <>
            <label
                className="form-field-label"
                style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '24px' }}
                htmlFor={htmlFor}
                {...props}
            >
                {markedResult === true ? (
                    <TickCircleIcon color="var(--green)" />
                ) : markedResult === false ? (
                    <CrossIcon color="var(--red)" />
                ) : (
                    ''
                )}
                {label}
            </label>
            <span className="form-field-description">{description}</span>
        </>
    );
};
